<template>
  <div class="col-sm-12 list-container nopads">
    <div v-if="tableItems.length > 0" class="result-table list-content">
        <vue3-datatable
            ref="resultTable"
            :rows="tableItems"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
            @row-click="emitEdit"
        >
        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: "ApplicationList",
    mixins: [timeUtils],
    components: {Vue3Datatable},
    props: {
        applications: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            tableItems: [],
            fields: [
                {field: 'subcontractor_name', title: this.$t('subcontractors.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'subcontractor_business_id', title: this.$t('subcontractors.business_id'), sort: true, headerClass: 'routa-table-header'},
                {field: 'customer', title: this.$t('subcontractors.customer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contractor', title: this.$t('subcontractors.contractor'), sort: true, headerClass: 'routa-table-header'},
                {field: 'period', title: this.$t('subcontractors.period'), sort: false, headerClass: 'routa-table-header'},
                {field: 'approved', title: this.$t('subcontractors.approval'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
      applications() {
          this.initTableItems()
      }
    },
    methods: {
        initTableItems() {
            this.tableItems = []
            const temp = []
            this.applications.forEach(app => {
                temp.push({
                    id: app.id,
                    subcontractor_name: app.subcontractor_name,
                    subcontractor_business_id: app.subcontractor_business_id,
                    customer: app.customer.name,
                    contractor: app.contractor.name,
                    period: this.getShortDateString(app.time_from) + ' - ' + this.getShortDateString(app.time_to),
                    approved: app.approval === 1 ? this.$t('work_permission.accepted') : app.approval === 2 ? this.$t('work_permission.rejected') : this.$t('subcontractors.unhandled'),
                    _rowVariant: this.hasEnded(app.time_to) ? 'warning' : app.approval === 1 ? 'success' : app.approval === 2 ? 'danger' :  null
                })
            })
            this.$nextTick(() => this.tableItems = temp)
        },
        emitEdit: function (application) {
            let item = this.applications.find(item => item.id === application.id)
            if (item) {
                this.$emit('edit', item)
            }
        },
        hasEnded (time) {
            let compare = new Date(this.getEndOfTheDay(time));
            let now = new Date();
            return compare.getTime() < now.getTime()
        }
    }
}
</script>
<style scoped lang="scss">
.approved {
    color: #ffffff;
    background: #1F7F35;
    padding: .2em;
}

.unhandled {
    color: #ffffff;
    background: #1E88E5;
    padding: .2em;
}

.rejected {
    color: #ffffff;
    background: #9e0c0c;
    padding: .2em;
}

</style>
